import React from "react";
import { Redirect } from "react-router-dom";

// Profile
import Profile from "../pages/Authentication/Profile";
import DefectElements from "../pages/DefectElements/DefectElements";
import UsersActivity from "../pages/UsersActivity/UsersActivity";
import SpecialSettings from "../pages/SpecialSettings/SpecialSettings";
import Timeouts from "../pages/Timeouts/Timeouts";

// Pages
import Occupancy from "../pages/Occupancy/Occupancy";
import Events from "../pages/Events/Events";
import Statistics from "../pages/Statistics/Statistics";
import Dashboard from "../pages/Dashboard/Dashboard";
// import Calendar from "../pages/Calendar/Calendar";
import Settings from "../pages/Settings/Settings";
import CarFinder from "../pages/CarFinder/CarFinder";
import AliveStatus from "../pages/SystemInfo/AliveStatus";
import CustomLogicAXAKoeln from "../pages/CustomLogics/AXAKoeln/AXAKoeln";
import PassageControlService from "../pages/PassageControlService/PassageControlService";
import StateControllerService from "../pages/StateControllerService/StateControllerService";

// Authentication related pages
import Login from "../pages/Authentication/Login";

const userRoutes = [
  {
    path: "/occupancy",
    exact: true,
    component: Occupancy,
    activeNavLink: "Occupancy",
  },
  {
    path: "/profile",
    exact: true,
    component: Profile,
    activeNavLink: "active",
  },
  {
    path: "/defectElements",
    exact: true,
    component: DefectElements,
    activeNavLink: "Dashboard",
  },
  {
    path: "/events",
    exact: true,
    component: Events,
    activeNavLink: "EventLogs",
  },
  {
    path: "/statistics",
    exact: true,
    component: Statistics,
    activeNavLink: "Statistics",
  },
  {
    path: "/dashboard",
    exact: true,
    component: Dashboard,
    activeNavLink: "Dashboard",
  },
  //   { path: "/calendar",exact: true, component: Calendar },
  {
    path: "/settings",
    exact: true,
    component: Settings,
    activeNavLink: "Settings",
  },
  {
    path: "/carfinder",
    exact: true,
    component: CarFinder,
    activeNavLink: "Carfinder",
  },
    {
        path: "/passageControlService",
        exact: true,
        component: PassageControlService,
        activeNavLink: "PassageControlService",
    },
    {
        path: "/stateControllerService",
        exact: true,
        component: StateControllerService,
        activeNavLink: "StateControllerService",
    },
  {
    path: "/aliveStatus",
    exact: true,
    component: AliveStatus,
    activeNavLink: "Dashboard",
  },
  {
    path: "/usersActivity",
    exact: true,
    component: UsersActivity,
    activeNavLink: "Dashboard",
  },
  {
    path: "/specialSettings",
    exact: true,
    component: SpecialSettings,
    activeNavLink: "Dashboard",
  },
  {
    path: "/timeouts",
    exact: true,
    component: Timeouts,
    activeNavLink: "Dashboard",
  },
    {
        path: "/axakoeln",
        exact: true,
        component: CustomLogicAXAKoeln,
        activeNavLink: "AXAKoelnParkpreise",
    },
  // this route should be at the end of all other routes
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/occupancy" />,
    activeNavLink: "Occupancy",
  },
];

const authRoutes = [{ path: "/login", component: Login }];

export { userRoutes, authRoutes };
